import type { ResponseLiked1monthAgo } from '../types/personShow';
import type { ResponseNotifications } from '../types/notifications';
import { wrapFetch } from '../libs/fetch';

export const fetchLiked1monthAgo = async (personId: number) => {
  return await wrapFetch<ResponseLiked1monthAgo>(`/api/v1/notifications/liked_within_one_month?id=${personId}`);
};

export const fetchNotifications = async (page: number) => {
  return await wrapFetch<ResponseNotifications>(`/api/v1/notifications?page=${page}`);
};

export const markReadAllNotifications = async (csrfToken: string) => {
  return await wrapFetch<{ success: boolean }>('/api/v1/notifications/mark_read_all', {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    credentials: 'same-origin',
  });
};
